import { hasTrackingStatus, isDeliveredStatus } from './sparePartsStatusColors'

/**
 * Availability and shipment status of a Spare Part Sales line (IS2-177).
 *
 * The backend sends both values already resolved on every line. The rules are repeated here
 * for two reasons: the screen must read correctly while a backend without these fields is
 * still deployed, and a line with a tracking number must never read as Backordered or as
 * Not shipped, whatever a stale payload says.
 */
export const LineAvailability = {
	BACKORDERED: 'Backordered',
	RELEASED: 'Released'
}

export const ShipmentStatus = {
	NOT_SHIPPED: 'NotShipped',
	IN_TRANSIT: 'InTransit',
	DELIVERED: 'Delivered'
}

const MEXICO_WAREHOUSE = 1

const SHIPMENT_STATUS_LABELS = {
	[ShipmentStatus.NOT_SHIPPED]: 'Not shipped',
	[ShipmentStatus.IN_TRANSIT]: 'In transit',
	[ShipmentStatus.DELIVERED]: 'Delivered'
}

export const availabilityOptions = [
	{ value: LineAvailability.BACKORDERED, label: LineAvailability.BACKORDERED },
	{ value: LineAvailability.RELEASED, label: LineAvailability.RELEASED }
]

/**
 * The availability a line shows: a tracking number always means Released; otherwise the value
 * the backend resolved (which already accounts for a manual adjustment); otherwise the default
 * rule — Mexico warehouse is Backordered, any other warehouse is Released.
 *
 * @param {object} item the spare-part line item
 * @returns {string} one of LineAvailability
 */
export const getLineAvailability = (item) => {
	if (hasTrackingStatus(item)) return LineAvailability.RELEASED
	if (Object.values(LineAvailability).includes(item && item.Availability)) return item.Availability
	return item && item.Warehouse === MEXICO_WAREHOUSE ? LineAvailability.BACKORDERED : LineAvailability.RELEASED
}

/**
 * The grouped shipment status of a line. No tracking number is Not shipped, whatever the payload
 * says; with one, the backend value wins when present, and otherwise the carrier status decides:
 * delivered is Delivered and anything else — including no status yet — is In transit.
 *
 * @param {object} item the spare-part line item
 * @returns {string} one of ShipmentStatus
 */
export const getShipmentStatus = (item) => {
	if (!hasTrackingStatus(item)) return ShipmentStatus.NOT_SHIPPED
	if (item.ShipmentStatus === ShipmentStatus.IN_TRANSIT || item.ShipmentStatus === ShipmentStatus.DELIVERED) return item.ShipmentStatus
	return isDeliveredStatus(item.Status) ? ShipmentStatus.DELIVERED : ShipmentStatus.IN_TRANSIT
}

export const getShipmentStatusLabel = (shipmentStatus) => SHIPMENT_STATUS_LABELS[shipmentStatus]
